import { MainLayout } from "@components/layouts/MainLayout";
import { LineChart } from "lucide-react";
import { PageHeader } from "@components/layouts/PageHeader";
import { Separator } from "@components/ui/separator";
import { useEffect, useState } from "react";
import { requestAppTweakApiData } from "../../helpers/requestAppTweakApiData";
import { ApplicationMetadata } from "../../components/apps/apptweak/ApplicationMetadata";

export default function AppTweak() {
  const [metadata, setMetadata] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    requestAppTweakApiData({
      country: "gb",
      language: "en",
      device: "iphone",
      "max-age": "86400",
    })
      .then(setMetadata)
      .catch((err: any) => setError(err.message || "Failed to fetch data"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <MainLayout>
      <div className="space-y-6 p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2">
          <PageHeader
            icon={<LineChart className="h-6 w-6 text-blue-600" />}
            title="App Tweak"
            subtitle="Metadata and metrics from AppTweak."
          />
        </div>
        <Separator className="mb-12" />
        <ApplicationMetadata data={metadata} loading={loading} error={error} />
      </div>
    </MainLayout>
  );
}
